<script>

import config from '../../common/genericPanelConf';
import Service from '../../services/stock-management';
import CommonConstants from '../../common/Constants';
import Utils from '../../common/Utils';
import GenericDataTable from '../../components/generic/GenericDataTable.vue';
import ResponsiveButton from '../../components/generic/ResponsiveButton.vue'

export default {
    props: ['category', 'name'],

    components: {
        GenericDataTable,
        ResponsiveButton,
    },
    data(){
        return{
            configuration: {},
            filters: {
                referenceDate: Utils.formatDatePlusDays(new Date(),-1),
            },
            twentyFour: '24.00',
        }
    },
    created(){
        this.configuration = config.getConfiguration('StockManagementLockedDaily');
        this.$store.dispatch('security/setNavbarTitle', this.configuration.title);
    },
    mounted(){
    },
    methods: {
        load(){
            let filters = {
                referenceDate: Utils.formatDateForAPI(Utils.formatDatePlusDays(this.filters.referenceDate, 1)),
            }
            this.$refs.StockManagementLockedDailyGrid.filterFromView(filters, true);
        },
        updateItem(item){
            Service.updateDailyLocked(item,  response => {
                if(response.success){
                    this.$toast.add({severity:'success', summary: 'Success Message', detail: this.$t('messages.update_message_success'), life: 3000});
                    this.$refs.StockManagementLockedDailyGrid.hideDialogEdit();
                    this.load();
                }else{
                    this.$toast.add({detail: response.message && response.message != '' ? response.message :  this.$t('messages.generic_error_message'), life:3000, severity:'error'});
                }
            });
        },
        onCreateLockedAssetRecord(){
            let referenceDate = Utils.formatDateForAPI(Utils.formatDatePlusDays(this.filters.referenceDate, 1));

            this.$confirm.require({
                message: this.$t('StockManagementDailyTank.createLockedAssetMessage'),
                icon: 'pi pi-exclamation-triangle',
                acceptLabel: this.$t('yes'),
                rejectLabel: this.$t('no'),
                accept: () => {
                    this.$store.dispatch("generic/setLoading", true);
                    Service.createLockedAssetRecord(referenceDate, response => {
                        this.$store.dispatch("generic/setLoading", false);
                        if(response.success){
                            this.load();
                        }else{
                            this.$toast.add({detail: response.message && response.message != '' ? response.message :  this.$t('messages.generic_error_message'), life:3000, severity:'error'});
                        }
                    })
                },
                reject: () => {
                    //callback to execute when user rejects the action
                }
            });
        }
    },
    computed: {
        constants(){
            return CommonConstants;
        },
        utils(){
            return Utils;
        },
        uiPermissions(){
            return this.$store.getters['security/uiPermissions'];
        },
    }
}
</script>

<style >

</style>

<template>
    <div class="grid">
        <div class="col-8 lg:col-2 field">
            <label for="referenceDate">{{$t('StockManagementDailyTank.referenceDate')}}</label>
            <Calendar
                :class="{'p-inputtext-sm w-full': true}"
                :placeholder="constants.DATE_PLACEHOLDER_POINT_ONLY_DATE"
                :dateFormat="constants.DATE_FORMAT_POINT"
                :showTime="false"
                v-model="filters.referenceDate"
                :showIcon="true" :showButtonBar="true" :yearNavigator="true" />
        </div>
        <div class="col-2 lg:col-1 field">
            <label>{{$t('at')}}</label>
            <InputText readOnly v-model="twentyFour" class="w-full " />
        </div>
        <div class="col-12 lg:col-7">
            <div class="p-3">
                <ResponsiveButton :label="$t('btn.load')" icon="pi pi-replay" class="mx-1 my-1" @click="load"/>
                <ResponsiveButton :label="$t('StockManagementDailyTank.btn.createLockedAsset')" icon="pi pi-download" class="mx-1 my-1" @click="onCreateLockedAssetRecord" :disabled="!uiPermissions('stockManagementCreateLockedAsset').isEnabled"/>
            </div>
        </div>
        <div class="col-12" style="height: calc(80vh)" >
            <GenericDataTable :configuration="configuration" category="stock-management" name="daily-locked" ref="StockManagementLockedDailyGrid" :onDialogEditSave="updateItem" />    
        </div>
    </div>
</template>